// removed by extract-text-webpack-plugin
module.exports = {"segment":"G293763"};